import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { CarritoProvider } from './context/CarritoContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ReactGA from "react-ga4";

ReactGA.initialize("G-SES2MJ1BY3");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CarritoProvider>
            <App />
      </CarritoProvider>      
    </LocalizationProvider>
  </React.StrictMode>
);

reportWebVitals();
